'use client';
import { GREY_100, SPACING_3 } from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';

export const Card = styled.div`
  border-radius: 1rem;
  border: 0;
  background: ${GREY_100};
  padding: ${SPACING_3};
`;
